import { useQueryGetBusinessCategories } from '@flecto/core/shared'
import { useTranslation } from '@flecto/translations'

export function useOnboardingSelectOptions() {
  const { t } = useTranslation('saas', { keyPrefix: 'onboarding' })
  const { data, isLoading } = useQueryGetBusinessCategories()

  const businessCategories = {
    data: (data ?? []).map((category) => ({
      value: category.id,
      label: category.name,
    })),
    isLoading,
  }

  const qtyEmployees = [
    {
      value: '0_10',
      label: '0 - 10',
    },
    {
      value: '10_50',
      label: '10 - 50',
    },
    {
      value: '50_200',
      label: '50 - 200',
    },
    {
      value: '200_500',
      label: '200 - 500',
    },
    {
      value: '500_1000',
      label: '500 - 1000',
    },
    {
      value: '1000+',
      label: '1000+',
    },
  ]

  const avgBookingsPerMonth = [
    {
      value: '0_10',
      label: '0 - 10',
    },
    {
      value: '10_50',
      label: '10 - 50',
    },
    {
      value: '50_100',
      label: '50 - 100',
    },
    {
      value: '100_500',
      label: '100 - 500',
    },
    {
      value: '500+',
      label: '500+',
    },
  ]

  const flectoProductsInterestedOn = [
    {
      value: 'flecto_saas',
      label: t('select_options.flecto_products_interested_on.flecto_saas'),
    },
    {
      value: 'flecto_store',
      label: t('select_options.flecto_products_interested_on.flecto_store'),
    },
    {
      value: 'flecto_insurance',
      label: t('select_options.flecto_products_interested_on.flecto_insurance'),
    },
    {
      value: 'flecto_invoicing',
      label: t('select_options.flecto_products_interested_on.flecto_invoicing'),
    },
  ]

  const systemsToReplace = [
    {
      value: 'sheets',
      label: t('select_options.systems_to_replace.sheets'),
    },
    {
      value: 'manual_processes',
      label: t('select_options.systems_to_replace.manual_processes'),
    },
    {
      value: 'rental_software',
      label: t('select_options.systems_to_replace.rental_software'),
    },
    {
      value: 'accounting_processes',
      label: t('select_options.systems_to_replace.accounting_processes'),
    },
    {
      value: 'e-commerce',
      label: t('select_options.systems_to_replace.e-commerce'),
    },
    {
      value: 'other',
      label: t('select_options.systems_to_replace.other'),
    },
  ]

  return {
    businessCategories,
    qtyEmployees,
    avgBookingsPerMonth,
    flectoProductsInterestedOn,
    systemsToReplace,
  }
}
